/* Chirppie landing page interactions: scroll reveal, FAQ accordion, sticky mobile cart,
   product gallery / swatch price sync.
   Progressive enhancement only: content is fully visible and functional by default (see
   chirppie-landing.css — the CSS-only radio gallery and native <form> work without JS), this
   script only adds nice-to-haves. No external dependencies. */
(function () {
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveal() {
    var items = document.querySelectorAll('.cc-reveal');
    if (!items.length || reduceMotion) return;

    if (!('IntersectionObserver' in window)) return;

    items.forEach(function (el) {
      el.classList.add('cc-reveal-armed');
    });

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('cc-in');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    items.forEach(function (el) { observer.observe(el); });
  }

  function initFaq() {
    document.querySelectorAll('[data-cc-faq]').forEach(function (list) {
      list.querySelectorAll('.cc-faq-q').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var item = btn.closest('.cc-faq-item');
          var isOpen = item.getAttribute('data-open') === 'true';
          list.querySelectorAll('.cc-faq-item').forEach(function (i) {
            i.setAttribute('data-open', 'false');
            var q = i.querySelector('.cc-faq-q');
            if (q) q.setAttribute('aria-expanded', 'false');
          });
          if (!isOpen) {
            item.setAttribute('data-open', 'true');
            btn.setAttribute('aria-expanded', 'true');
          }
        });
      });
    });
  }

  /* Updates the price snippet's specific number spans on variant change instead of
     overwriting the whole container — textContent-replacing the container would delete
     the compare-at <s> strikethrough element rendered by snippets/price.liquid. */
  function initPdpPrice() {
    document.querySelectorAll('.cc-pdp-buybox').forEach(function (box) {
      var priceEl = box.querySelector('[data-cc-pdp-price]');
      if (!priceEl) return;
      var priceContainer = priceEl.querySelector('.price');
      var saleAmount = priceEl.querySelector('.price__sale .price-item--sale');
      var saleCompare = priceEl.querySelector('.price__sale .price-item--regular');
      var regularAmount = priceEl.querySelector('.price__regular .price-item--regular');
      box.querySelectorAll('input[type="radio"][name="id"]').forEach(function (input) {
        input.addEventListener('change', function () {
          if (!input.checked || !input.dataset.price) return;
          if (saleAmount) saleAmount.textContent = input.dataset.price;
          if (regularAmount) regularAmount.textContent = input.dataset.price;
          var compareAt = input.dataset.compareAtPrice;
          if (saleCompare && compareAt) saleCompare.textContent = compareAt;
          if (priceContainer) priceContainer.classList.toggle('price--on-sale', !!compareAt);
        });
      });
    });
  }

  function initPdpGallery() {
    document.querySelectorAll('[data-cc-pdp-gallery]').forEach(function (gallery) {
      var wrap = gallery.closest('.cc-pdp-grid');
      if (!wrap) return;
      var variantInputs = wrap.querySelectorAll('.cc-pdp-buybox input[type="radio"][name="id"]');
      if (!variantInputs.length) return;

      var radios = Array.prototype.slice.call(gallery.querySelectorAll('.cc-pdp-radio'));
      var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('.cc-pdp-thumb'));

      function showVariant(variantId) {
        var firstMatch = null;
        var checkedStillVisible = false;
        radios.forEach(function (radio, i) {
          var tag = radio.getAttribute('data-variant-ids') || '';
          var visible = tag === '' || tag === variantId;
          var thumb = thumbs[i];
          if (thumb) thumb.style.display = visible ? '' : 'none';
          if (visible && !firstMatch) firstMatch = radio;
          if (visible && radio.checked) checkedStillVisible = true;
        });
        if (!checkedStillVisible && firstMatch) {
          firstMatch.checked = true;
        }
      }

      variantInputs.forEach(function (input) {
        input.addEventListener('change', function () {
          if (input.checked) showVariant(input.value);
        });
      });

      var checkedVariant = wrap.querySelector('.cc-pdp-buybox input[type="radio"][name="id"]:checked');
      if (checkedVariant) showVariant(checkedVariant.value);
    });
  }

  function initCtaImageSync() {
    document.querySelectorAll('.cc-inline-cta-grid').forEach(function (grid) {
      var media = Array.prototype.slice.call(grid.querySelectorAll('.cc-inline-cta-media[data-variant-ids]'));
      if (media.length < 2) return;

      function show(variantId) {
        var matched = false;
        media.forEach(function (m) {
          var tag = m.getAttribute('data-variant-ids') || '';
          var visible = tag === variantId;
          m.classList.toggle('cc-active', visible);
          if (visible) matched = true;
        });
        if (!matched) media[0].classList.add('cc-active');
      }

      var select = grid.querySelector('select[name="id"]');
      if (select) {
        select.addEventListener('change', function () { show(select.value); });
        show(select.value);
      }

      var radios = grid.querySelectorAll('input[type="radio"][name="id"]');
      if (radios.length) {
        radios.forEach(function (r) {
          r.addEventListener('change', function () { if (r.checked) show(r.value); });
        });
        var checked = grid.querySelector('input[type="radio"][name="id"]:checked');
        if (checked) show(checked.value);
      }
    });
  }

  /* Site-wide variant sync: this page renders several independent buy forms (hero,
     product gallery swatches, inline CTAs, final CTA), each with its own <select name="id">
     or radio-swatch group. Picking Green in one used to leave the others showing Blue.
     This listens for a change on ANY of them and applies the same variant id to every
     other one, dispatching a real 'change' event so each section's own existing logic
     (gallery image filtering, CTA photo swap, price display) fires normally — no other
     function needs to know this exists. A `syncing` guard stops the dispatched events
     from re-entering this same handler and looping. */
  function initGlobalVariantSync() {
    function allVariantInputs() {
      return Array.prototype.slice.call(document.querySelectorAll('input[type="radio"][name="id"], select[name="id"]'));
    }

    var inputs = allVariantInputs();
    if (inputs.length < 2) return;

    var syncing = false;

    function applyVariant(variantId, source) {
      if (syncing) return;
      syncing = true;
      allVariantInputs().forEach(function (el) {
        if (el === source) return;
        if (el.tagName === 'SELECT') {
          if (el.value !== variantId) {
            var hasOption = Array.prototype.some.call(el.options, function (o) { return o.value === variantId; });
            if (hasOption) {
              el.value = variantId;
              el.dispatchEvent(new Event('change', { bubbles: true }));
            }
          }
        } else if (el.type === 'radio' && el.value === variantId && !el.checked) {
          el.checked = true;
          el.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
      syncing = false;
    }

    inputs.forEach(function (el) {
      el.addEventListener('change', function () {
        if (syncing) return;
        applyVariant(el.value, el);
      });
    });
  }

  /* Low-stock notice ("Only X available"): each buy-form's variant picker (radio swatches
     or a <select>) carries data-inventory-management / data-inventory-quantity on every
     option/radio (see snippets/chirppie-buy-form.liquid). The notice text for the initially
     selected variant is already correct server-side on load; this only has to update it when
     the shopper picks a different variant, including when initGlobalVariantSync mirrors a
     pick from one buy-form onto the others (it dispatches a real 'change' event on each, so
     this listener fires there too — no extra wiring needed). */
  function initStockNotice() {
    function updateNotice(optionOrRadio) {
      var form = optionOrRadio.closest('form');
      if (!form) return;
      var notice = form.querySelector('[data-cc-stock-notice]');
      if (!notice) return;
      var mgmt = optionOrRadio.dataset.inventoryManagement;
      var qty = parseInt(optionOrRadio.dataset.inventoryQuantity, 10);
      if (mgmt === 'shopify' && !isNaN(qty) && qty > 0 && qty <= 10) {
        notice.textContent = 'Only ' + qty + ' available';
        notice.hidden = false;
      } else {
        notice.textContent = '';
        notice.hidden = true;
      }
    }

    document.querySelectorAll('input[type="radio"][name="id"], select[name="id"]').forEach(function (el) {
      el.addEventListener('change', function () {
        if (el.tagName === 'SELECT') {
          var opt = el.options[el.selectedIndex];
          if (opt) updateNotice(opt);
        } else {
          updateNotice(el);
        }
      });
    });
  }

  /* Color-aware "Buy on Amazon" link: each such link (hero, product gallery) carries
     data-variant-id-blue/-green and data-url-blue/-green (see sections/chirppie-hero.liquid,
     sections/chirppie-product-gallery.liquid). Its initial href is already correct for the
     page's starting variant; this only has to update it when the shopper picks a different
     color — including a pick made in a DIFFERENT buy-form, via the same global 'change'
     broadcast initGlobalVariantSync/initStockNotice already listen for. */
  function initAmazonLink() {
    var links = document.querySelectorAll('[data-cc-amazon-link]');
    if (!links.length) return;

    function applyVariant(variantId) {
      links.forEach(function (link) {
        if (variantId && variantId === link.dataset.variantIdBlue && link.dataset.urlBlue) {
          link.href = link.dataset.urlBlue;
        } else if (variantId && variantId === link.dataset.variantIdGreen && link.dataset.urlGreen) {
          link.href = link.dataset.urlGreen;
        }
      });
    }

    document.querySelectorAll('input[type="radio"][name="id"], select[name="id"]').forEach(function (el) {
      el.addEventListener('change', function () {
        applyVariant(el.value);
      });
    });
  }

  /* Mobile "scroll for more" cue: only relevant on narrow screens where the hero is a
     single screenful and it isn't obvious there's more content below. Scrolls to the next
     REAL section instead of an arbitrary pixel offset so it lands cleanly regardless of
     hero height. Shopify wraps every section in its own "shopify-section" div (plus an
     auto-injected <style> tag for custom_css) — .cc-hero's only sibling is that <style>
     tag inside its own wrapper, so the actual next section lives one level up, as a
     sibling of the wrapper, not of .cc-hero itself. Still walks past any non-rendering
     siblings either way, just in case.
     Hidden automatically on desktop via CSS (see .cc-scroll-cue). */
  function initScrollCue() {
    var cue = document.querySelector('[data-cc-scroll-cue]');
    if (!cue) return;
    cue.addEventListener('click', function (e) {
      e.preventDefault();
      var hero = cue.closest('.cc-hero');
      if (!hero) return;
      var wrapper = hero.closest('[id^="shopify-section-"]') || hero.parentElement;
      var next = wrapper ? wrapper.nextElementSibling : null;
      while (next && (next.tagName === 'STYLE' || next.tagName === 'SCRIPT' || next.offsetHeight === 0)) {
        next = next.nextElementSibling;
      }
      if (next && next.scrollIntoView) {
        next.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initReveal();
    initFaq();
    initPdpPrice();
    initPdpGallery();
    initCtaImageSync();
    initGlobalVariantSync();
    initStockNotice();
    initAmazonLink();
    initScrollCue();
  });
})();


